import React, { useEffect, useState } from 'react';
import TextBox from '../../components/TextBox';
import AutoCompleteBank from '../../components/AutoCompleteBank';
import { Abc, Add, Numbers } from '@mui/icons-material';
import { Box } from '@mui/material';
import CustomSnackBar from '../../components/CustomSnackBar';
import API from '../../services/api';
import ButtonSubmit from '../../components/ButtonSubmit';
import { BANK_OPTIONS } from '../../constants/banks';

export default function CreateBankAcc({ supplier = 0, setOpen, data, onClose }) {
    const [selectedBank, setSelectedBank] = useState(null);
    const [selectedAccType, setSelectedAccType] = useState(null);
    const [openSnack, setOpenSnack] = useState(false);
    const [loading, setLoading] = useState(false);
    const [snackMessage, setSnackMessage] = useState('');
    const [snackSeverity, setSnackSeverity] = useState('info');
    const [accNameTouched, setAccNameTouched] = useState(false);
    const [formData, setFormData] = useState({
        bankName: '',
        accNumber: '',
        accType: true,
        accName: '',
        supplier,
    });

    const accTypes = [
        { id: 1, name: 'Monetaria' },
        { id: 2, name: 'Ahorros' },
    ];

    const handleBankChange = (name, value) => {
        setSelectedBank(value);
        setFormData((prev) => ({
            ...prev,
            [name]: value ? value.name : '',
        }));
    };

    const handleAccTypeChange = (name, value) => {
        setSelectedAccType(value);
        setFormData((prev) => ({
            ...prev,
            [name]: value ? value.name : '',
        }));
    };

    const handleChange = (name, value) => {
        if (name === 'accName') {
            setAccNameTouched(true);
        }
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            setLoading(true);
            await API.post('bank-account/', formData);

            setOpenSnack(true);
            setSnackMessage('Creado con exito');
            setSnackSeverity('success');

            setTimeout(() => {
                setLoading(false);
                onClose?.();
                data?.();
            }, 1500);
        } catch (error) {
            console.error('Error:', error);
            setOpenSnack(true);
            setSnackMessage('Intente de nuevo');
            setSnackSeverity('error');
            setLoading(false);
        }
    };

    useEffect(() => {
        setFormData((prev) => ({ ...prev, supplier: supplier || prev.supplier || 0 }));
    }, [supplier]);

    useEffect(() => {
        let mounted = true;
        if (!supplier || accNameTouched) return () => { mounted = false; };
        (async () => {
            try {
                const res = await API.get(`suppliers/${supplier}/`);
                const legalName = res?.data?.legalName || '';
                if (mounted && legalName && !accNameTouched) {
                    setFormData((prev) => ({
                        ...prev,
                        accName: prev.accName || legalName,
                    }));
                }
            } catch {
                // ignore
            }
        })();
        return () => { mounted = false; };
    }, [supplier, accNameTouched]);

    return (
        <Box
            component="form"
            onSubmit={handleSubmit}
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                width: '100%',
                maxWidth: 500,
                margin: '0 auto',
                gap: 0,
            }}
        >
            <TextBox
                label="Numero de cuenta"
                type="number"
                icon={Numbers}
                maxLength={15}
                name="accNumber"
                onChange={handleChange}
            />

            <TextBox
                label="Nombre de cuenta"
                type="text"
                icon={Abc}
                maxLength={29}
                name="accName"
                onChange={handleChange}
            />

            <AutoCompleteBank
                options={BANK_OPTIONS}
                getOptionLabel={(option) => option.name}
                onChange={handleBankChange}
                name="bankName"
                value={selectedBank}
                label="Nombre del banco"
                sx={{ width: '100%' }}
            />

            <AutoCompleteBank
                options={accTypes}
                getOptionLabel={(option) => option.name}
                onChange={handleAccTypeChange}
                name="accType"
                value={selectedAccType}
                label="Tipo de cuenta"
                sx={{ width: '100%' }}
                marginBottom="1px"
            />

            <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', mt: 1 }}>
                <ButtonSubmit
                    name="Crear"
                    icon={Add}
                    loading={loading}
                    color="primary"
                    sx={{ width: '100%', maxWidth: 200 }}
                />
            </Box>

            {openSnack && (
                <CustomSnackBar
                    open={openSnack}
                    setOpen={setOpenSnack}
                    message={snackMessage}
                    severity={snackSeverity}
                    loading={loading}
                />
            )}
        </Box>
    );
}
